export enum PageTransitions {
  NONE = '',
  SLIDE_IN_FROM_BOTTOM = 'slide-in-from-bottom',
  SLIDE_OUT_TO_BOTTOM = 'slide-out-to-bottom',
  SLIDE_IN_FROM_RIGHT = 'slide-in-from-right',
  SLIDE_OUT_TO_LEFT = 'slide-out-to-left',
  SLIDE_IN_FROM_LEFT = 'slide-in-from-left',
  SLIDE_IN_FROM_TOP = 'slide-in-from-top',
  FAST_FADE_IN = 'fast-fade-in',
  FAST_FADE_OUT = 'fast-fade-out',
  FADE_IN = 'fade-in',
  FADE_OUT = 'fade-out',
  HIDDEN_TO_UNSET = 'hidden-to-unset',
  HIDDEN = 'hidden',
}
